import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { statusValidationForm } from "../../utils/validationSchema";
import StatusForm from "./StatusForm";
import Form from "../../layouts/Form";

const CreateStatus = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(statusValidationForm),
  });
  const { handleCreate, statusList, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <StatusForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        statusList={statusList}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
      />
    </Form>
  );
};

export default CreateStatus;
